export const GLOBAL_INFO = 'global.GLOBAL_INFO';
export const RESET_GLOBAL_INFO = 'global.RESET_GLOBAL_INFO'
export const GLOBAL_ERROR = 'global.GLOBAL_ERROR';
export const RESET_GLOBAL_ERROR = 'global.RESET_GLOBAL_ERROR'